"use strict";
// tslint:disable
/**
 * Conversations service API
 * Conversations API is used to manage streams (topic based), one-on-one, and group conversations.  All resources except `_spec` are secured by an API token passed in the Authorization header.  Collection requests support basic OData syntax.  To manipulate paged data utilize the `$skip` & `$top` query string syntax. For example: * Get first 5 results: `/2017-09-01/conversations?$top=5` * Skip 5 then get next 5 results: `/2017-09-01/conversations?$skip=5&$top=5`  Basic filter syntax is supported for targeted queries.  For example: * Get conversations that are streams: `/2017-09-01/conversations?$filter=stream eq true` * Get one-on-one and group conversations: `/2017-09-01/conversations?$filter=stream eq false`  In addition to OData, other query parameters are situationally supported: * Find conversations with a specific set of participants: `/2017-09-01/conversations?participants=contains-exact(part1,part2,part3,...)`  Conversations supports events from the notifications service.  Conversation events have the following information: * topic set to `platform-api-conversations` * subject matching the self link or route of created or edited resource * content matching what was returned to the caller Note: In order to receive notifications, the user must be a participant of the conversation.  This provides consumers with a symmetric experience whether using the REST calls or receiving asynchronous notifications.  Some example subscription filters are: * Messages for all conversations:  `^/2017-09-01/conversations/[^/]+/messages/[^/]+$` * Subresources for a conversation with id '1234':  `^/2017-09-01/conversations/1234/`  Any time a users own `userId` or `participantId` is to be specified in a path or query parameter, the alias `me` may be substituted. Note: this alias will not work in the body of a request.
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * ChatService
 * @class
 */
class ChatService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-conversations',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Chat' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Deletes the attachment for the provided ID. This route may not be used in conversations with SMS participants.
    * @summary Delete an attachment
    * @param {string} conversationId ConversationId
    * @param {string} attachmentId AttachmentId
    * @throws {RequiredError}
    */
    deleteAttachment(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling deleteAttachment.');
        }
        // verify required parameter 'attachmentId' is not null or undefined
        if (params.attachmentId === null || params.attachmentId === undefined) {
            throw new utils_1.RequiredError('attachmentId', 'Required parameter attachmentId was null or undefined when calling deleteAttachment.');
        }
        const path = `/conversations/{conversationId}/attachments/{attachmentId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'attachmentId'}}`, String(params.attachmentId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the attachment for the provided ID. This route may not be used in conversations with SMS participants.
    * @summary Get an attachment
    * @param {string} conversationId ConversationId
    * @param {string} attachmentId AttachmentId
    * @throws {RequiredError}
    */
    getAttachment(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getAttachment.');
        }
        // verify required parameter 'attachmentId' is not null or undefined
        if (params.attachmentId === null || params.attachmentId === undefined) {
            throw new utils_1.RequiredError('attachmentId', 'Required parameter attachmentId was null or undefined when calling getAttachment.');
        }
        const path = `/conversations/{conversationId}/attachments/{attachmentId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'attachmentId'}}`, String(params.attachmentId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the attachment metadata for the provided ID. This route may not be used in conversations with SMS participants.
    * @summary Get attachment metadata
    * @param {string} conversationId ConversationId
    * @param {string} attachmentId AttachmentId
    * @throws {RequiredError}
    */
    getAttachmentMeta(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getAttachmentMeta.');
        }
        // verify required parameter 'attachmentId' is not null or undefined
        if (params.attachmentId === null || params.attachmentId === undefined) {
            throw new utils_1.RequiredError('attachmentId', 'Required parameter attachmentId was null or undefined when calling getAttachmentMeta.');
        }
        const path = `/conversations/{conversationId}/attachments/{attachmentId}/meta`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'attachmentId'}}`, String(params.attachmentId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get attachment metadata for this conversation. This route may not be used in conversations with SMS participants.
    * @summary Get attachments
    * @param {string} conversationId ConversationId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Search] Odata search param
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getAttachments(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getAttachments.');
        }
        const path = `/conversations/{conversationId}/attachments`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the attachment for the provided ID. If the ID does not exist, it is created. The maximum size for an attachment is 10MB. This route may not be used in conversations with SMS participants.
    * @summary Create or update an attachment
    * @param {string} conversationId ConversationId
    * @param {string} attachmentId AttachmentId
    * @param {string} body Binary data of the attachment
    * @throws {RequiredError}
    */
    updateAttachment(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateAttachment.');
        }
        // verify required parameter 'attachmentId' is not null or undefined
        if (params.attachmentId === null || params.attachmentId === undefined) {
            throw new utils_1.RequiredError('attachmentId', 'Required parameter attachmentId was null or undefined when calling updateAttachment.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAttachment.');
        }
        const path = `/conversations/{conversationId}/attachments/{attachmentId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'attachmentId'}}`, String(params.attachmentId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the attachment metadata for the provided ID. This route may not be used in conversations with SMS participants.
    * @summary Update an attachments metadata
    * @param {string} conversationId ConversationId
    * @param {string} attachmentId AttachmentId
    * @param {AttachmentPutRequest} body Binary data of the attachment
    * @throws {RequiredError}
    */
    updateAttachmentMeta(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateAttachmentMeta.');
        }
        // verify required parameter 'attachmentId' is not null or undefined
        if (params.attachmentId === null || params.attachmentId === undefined) {
            throw new utils_1.RequiredError('attachmentId', 'Required parameter attachmentId was null or undefined when calling updateAttachmentMeta.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAttachmentMeta.');
        }
        const path = `/conversations/{conversationId}/attachments/{attachmentId}/meta`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'attachmentId'}}`, String(params.attachmentId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a command. Output values can contain `{{inputParameterName}}` to pass through parameter values.
    * @summary Post command
    * @param {CommandCreateRequest} body Command POST request object
    * @throws {RequiredError}
    */
    createCommand(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createCommand.');
        }
        const path = `/commands`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the command for the provided ID.
    * @summary Delete a command
    * @param {string} commandId CommandId
    * @throws {RequiredError}
    */
    deleteCommand(params) {
        // verify required parameter 'commandId' is not null or undefined
        if (params.commandId === null || params.commandId === undefined) {
            throw new utils_1.RequiredError('commandId', 'Required parameter commandId was null or undefined when calling deleteCommand.');
        }
        const path = `/commands/{commandId}`
            .replace(`{${'commandId'}}`, String(params.commandId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Execute a command. Note, the return type will vary by the command being run.
    * @summary Post command
    * @param {string} commandId CommandId
    * @param {CommandExecuteRequest} [body] Arguments for the command
    * @throws {RequiredError}
    */
    executeCommand(params) {
        // verify required parameter 'commandId' is not null or undefined
        if (params.commandId === null || params.commandId === undefined) {
            throw new utils_1.RequiredError('commandId', 'Required parameter commandId was null or undefined when calling executeCommand.');
        }
        const path = `/commands/{commandId}`
            .replace(`{${'commandId'}}`, String(params.commandId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve a list of the available commands
    * @summary Get command
    * @param {string} commandId CommandId
    * @throws {RequiredError}
    */
    getCommand(params) {
        // verify required parameter 'commandId' is not null or undefined
        if (params.commandId === null || params.commandId === undefined) {
            throw new utils_1.RequiredError('commandId', 'Required parameter commandId was null or undefined when calling getCommand.');
        }
        const path = `/commands/{commandId}`
            .replace(`{${'commandId'}}`, String(params.commandId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve a list of the available commands
    * @summary Get commands
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [conversationId] ID of the relevant conversation
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getCommands(params) {
        const path = `/commands`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.conversationId !== undefined) {
            query['conversationId'] = params.conversationId;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the command for the provided ID.
    * @summary Update a command
    * @param {string} commandId CommandId
    * @param {CommandPutRequest} [body] Command PUT request object
    * @throws {RequiredError}
    */
    updateCommand(params) {
        // verify required parameter 'commandId' is not null or undefined
        if (params.commandId === null || params.commandId === undefined) {
            throw new utils_1.RequiredError('commandId', 'Required parameter commandId was null or undefined when calling updateCommand.');
        }
        const path = `/commands/{commandId}`
            .replace(`{${'commandId'}}`, String(params.commandId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a conversation with the provided body parameters. * To create a stream:  `{\"name\": \"atopic\", \"stream\": true}` * To create a one-on-one based or group private conversation:`{\"participants\": [\"jim@example.com\", \"sam@example.com\"]}` Streams are created with a unique name while direct is created with participants (do not provide a name, else a 400 is returned). To add participants to a stream use the participants resource.  For direct conversations that already exist, a 200 will be returned with the conversation in question.
    * @summary Create a conversation
    * @param {ConversationPostRequest} body Conversation POST request object
    * @throws {RequiredError}
    */
    createConversation(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createConversation.');
        }
        const path = `/conversations`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the conversation for the provided ID.  This is not a reversible operation and will delete all conversation messages, participants, and attachments.
    * @summary Delete a conversation
    * @param {string} conversationId ConversationId
    * @throws {RequiredError}
    */
    deleteConversation(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling deleteConversation.');
        }
        const path = `/conversations/{conversationId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the conversation for the provided ID.
    * @summary Get a conversation
    * @param {string} conversationId ConversationId
    * @throws {RequiredError}
    */
    getConversation(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getConversation.');
        }
        const path = `/conversations/{conversationId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all conversations for the current token including streams (public or private), one-on-one, and group conversations. Data is paged on the server and sorted by most recent conversations first. *Expandable subresources: message, participant
    * @summary Get conversations
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Search] Odata search param
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @param {string} [$Expand] Specify which sub-resources to include in the response. Supports the following Odata for embedded resources: $filter, $orderby, $select, $skip, $top ($expand is also supported where applicable).  Eg: &#x60;/messages?$expand&#x3D;status,reaction($filter&#x3D;reaction eq &#39;👍&#39;;$orderby&#x3D;userId asc)&#x60;
    * @param {string} [participants] Values:  - contains-exact(user-id-1, user-id-2, ...): Returns conversations with exactly the provided participants (none missing, none extra).
    * @throws {RequiredError}
    */
    getConversations(params) {
        const path = `/conversations`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.participants !== undefined) {
            query['participants'] = params.participants;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create transcript with all the messages in a conversation
    * @summary Create conversation transcript
    * @param {string} conversationId ConversationId
    * @param {TranscriptPostRequest} body Transcript POST request object
    * @throws {RequiredError}
    */
    postTranscripts(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling postTranscripts.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling postTranscripts.');
        }
        const path = `/conversations/{conversationId}/transcripts`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns search results based on the provided OData Parameters.
    * @summary Search resources under conversations
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Search] Odata search param
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @throws {RequiredError}
    */
    searchContent(params) {
        const path = `/conversations/content`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the conversation for the provided ID.
    * @summary Update a conversation
    * @param {string} conversationId ConversationId
    * @param {ConversationPutRequest} body Conversation PUT request object
    * @throws {RequiredError}
    */
    updateConversation(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateConversation.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateConversation.');
        }
        const path = `/conversations/{conversationId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a message in the conversation with the provided ID. If a large message (greater than 1024 characters) is of content-type 'text/plain', it may be split into multiple messages.
    * @summary Create a message
    * @param {string} conversationId ConversationId
    * @param {MessagePostRequest} body Message POST request object
    * @throws {RequiredError}
    */
    createMessage(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling createMessage.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createMessage.');
        }
        const path = `/conversations/{conversationId}/messages`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete the message for the provided ID.
    * @summary Delete a message
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @throws {RequiredError}
    */
    deleteMessage(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling deleteMessage.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling deleteMessage.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the message for the provided ID *Expandable subresources: reaction, reply, status, translation
    * @summary Get a message
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @param {string} [$Expand] Specify which sub-resources to include in the response. Supports the following Odata for embedded resources: $filter, $orderby, $select, $skip, $top ($expand is also supported where applicable).  Eg: &#x60;/messages?$expand&#x3D;status,reaction($filter&#x3D;reaction eq &#39;👍&#39;;$orderby&#x3D;userId asc)&#x60;
    * @throws {RequiredError}
    */
    getMessage(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getMessage.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getMessage.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all top level messages for the conversation with the provided ID. Data is paged on the server and sorted by most recent messages first. To manipulate paged data utilize the $filter, $skip, & $top query string syntax: *Expandable subresources: reaction, reply, status, translation * Return top 5 results: `/2017-09-01/conversations/{conversationId}/messages?$top=5` * Skip 5 then return top 5 results: `/2017-09-01/conversations/{conversationId}/messages?$skip=5&$top=5`
    * @summary Get messages
    * @param {string} conversationId ConversationId
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Search] Odata search param
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @param {string} [$Expand] Specify which sub-resources to include in the response. Supports the following Odata for embedded resources: $filter, $orderby, $select, $skip, $top ($expand is also supported where applicable).  Eg: &#x60;/messages?$expand&#x3D;status,reaction($filter&#x3D;reaction eq &#39;👍&#39;;$orderby&#x3D;userId asc)&#x60;
    * @throws {RequiredError}
    */
    getMessages(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getMessages.');
        }
        const path = `/conversations/{conversationId}/messages`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get direct replies to the message with the provided ID. This does not recurse. To interact with a reply, you interact with it as a message.  Replies are messages and can be nested indefinitely but the URLs don't change. Consider the following scenario:  message1 * reply1   * reply1.1 * reply2   * reply2.1 * reply3  In this scenario: * `/messages` would give message1 only. message1 would have the replies URL in the `_links.replies`. * `/messages/message1/replies` would give reply1 and reply2, both with replies under `_links.replies`, and reply3 with no replies under links. * `/messages/reply1` would return reply1.1 which would have no replies link.
    * @summary Get replies
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getReplies(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getReplies.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getReplies.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/replies`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the message for the provided ID.  Can be used to edit previously posted message bodies.  This allows a system to allow users to correct mistakes or a redact sensitive information.
    * @summary Update a message
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {MessagePutRequest} body Message PUT request object
    * @throws {RequiredError}
    */
    updateMessage(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateMessage.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling updateMessage.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateMessage.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get message status for a participant of a conversation
    * @summary Get message status
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} participantId ParticipantId or &#39;me&#39;
    * @throws {RequiredError}
    */
    getMessageStatus(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getMessageStatus.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getMessageStatus.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling getMessageStatus.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/statuses/{participantId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get message statuses for conversation participants.
    * @summary Get message statuses
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getMessageStatuses(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getMessageStatuses.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getMessageStatuses.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/statuses`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Trigger resending a message to a participant in a conversation. This will return 400 (Bad Request) if the message status for this participant is not 'FAILED'.
    * @summary Resend failed message
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} participantId ParticipantId or &#39;me&#39;
    * @param {MessageStatusPutRequest} body Message status PUT request object
    * @throws {RequiredError}
    */
    putMessageStatus(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling putMessageStatus.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling putMessageStatus.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling putMessageStatus.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling putMessageStatus.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/statuses/{participantId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a participant for the conversation with the provided ID. This only applies to stream/topic based conversations. One-on-one and group chats require the creation of a new conversation when the participant list changes. This sets the given userId to 'INVITED' and triggers an invite.
    * @summary Create a participant
    * @param {string} conversationId ConversationId
    * @param {ParticipantPostRequest} body Participant POST request object
    * @throws {RequiredError}
    */
    createParticipant(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling createParticipant.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createParticipant.');
        }
        const path = `/conversations/{conversationId}/participants`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the participant for the provided ID.
    * @summary Delete a participant
    * @param {string} conversationId ConversationId
    * @param {string} participantId ParticipantId or &#39;me&#39;
    * @throws {RequiredError}
    */
    deleteParticipant(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling deleteParticipant.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling deleteParticipant.');
        }
        const path = `/conversations/{conversationId}/participants/{participantId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the participant for the provided ID.
    * @summary Gets a participant
    * @param {string} conversationId ConversationId
    * @param {string} participantId ParticipantId or &#39;me&#39;
    * @throws {RequiredError}
    */
    getParticipant(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getParticipant.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling getParticipant.');
        }
        const path = `/conversations/{conversationId}/participants/{participantId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the participants for a conversation with the provided ID.
    * @summary Get participants
    * @param {string} conversationId ConversationId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getParticipants(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getParticipants.');
        }
        const path = `/conversations/{conversationId}/participants`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used by applications to inform other applications of users typing.  It's up to the applications to decide on the frequency of sending and the interpretation of when typing would stop.
    * @summary Sends typing message for a participant
    * @param {string} conversationId ConversationId
    * @param {string} participantId ParticipantId or &#39;me&#39;
    * @param {ParticipantPostTypingAction} [body] Participant typing action object
    * @throws {RequiredError}
    */
    sendParticipantTyping(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling sendParticipantTyping.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling sendParticipantTyping.');
        }
        const path = `/conversations/{conversationId}/participants/{participantId}/typing`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the participant for the provided ID. This is used to ACCEPT or DECLINE an invitation or to update the last read message for read receipts.
    * @summary Update a participant
    * @param {string} conversationId ConversationId
    * @param {string} participantId ParticipantId or &#39;me&#39;
    * @param {ParticipantPutRequest} body Participant PUT request object
    * @throws {RequiredError}
    */
    updateParticipant(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateParticipant.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling updateParticipant.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateParticipant.');
        }
        const path = `/conversations/{conversationId}/participants/{participantId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a reaction to a message. Reactions contain exactly 1 character. A reaction character may not be whitespace.
    * @summary Create a reaction to a message
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {ReactionPostRequest} body Reaction POST request object
    * @throws {RequiredError}
    */
    createReaction(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling createReaction.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling createReaction.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createReaction.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/reactions`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete the reaction for the provided ID.
    * @summary Delete a reaction
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} reactionId ReactionId
    * @throws {RequiredError}
    */
    deleteReaction(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling deleteReaction.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling deleteReaction.');
        }
        // verify required parameter 'reactionId' is not null or undefined
        if (params.reactionId === null || params.reactionId === undefined) {
            throw new utils_1.RequiredError('reactionId', 'Required parameter reactionId was null or undefined when calling deleteReaction.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/reactions/{reactionId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId))
            .replace(`{${'reactionId'}}`, String(params.reactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the reactions to this message.
    * @summary Get message reactions
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getMessagesReactions(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getMessagesReactions.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getMessagesReactions.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/reactions`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the reaction for the provided ID
    * @summary Get a reaction
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} reactionId ReactionId
    * @throws {RequiredError}
    */
    getReaction(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getReaction.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getReaction.');
        }
        // verify required parameter 'reactionId' is not null or undefined
        if (params.reactionId === null || params.reactionId === undefined) {
            throw new utils_1.RequiredError('reactionId', 'Required parameter reactionId was null or undefined when calling getReaction.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/reactions/{reactionId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId))
            .replace(`{${'reactionId'}}`, String(params.reactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a previously posted reaction.
    * @summary Update a reaction
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} reactionId ReactionId
    * @param {ReactionPutRequest} body Reaction PUT request object
    * @throws {RequiredError}
    */
    updateReaction(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateReaction.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling updateReaction.');
        }
        // verify required parameter 'reactionId' is not null or undefined
        if (params.reactionId === null || params.reactionId === undefined) {
            throw new utils_1.RequiredError('reactionId', 'Required parameter reactionId was null or undefined when calling updateReaction.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateReaction.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/reactions/{reactionId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId))
            .replace(`{${'reactionId'}}`, String(params.reactionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides this specification defining the resources of the service API
    * @summary Get API spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the status of the microservice
    * @summary Get microservice status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a tag for the conversation with the provided ID.
    * @summary Create a tag
    * @param {string} conversationId ConversationId
    * @param {TagPostRequest} body Tag POST request object
    * @throws {RequiredError}
    */
    createTag(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling createTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createTag.');
        }
        const path = `/conversations/{conversationId}/tags`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the tag for the provided ID.
    * @summary Delete a tag
    * @param {string} conversationId ConversationId
    * @param {string} tagId TagId
    * @throws {RequiredError}
    */
    deleteTag(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling deleteTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteTag.');
        }
        const path = `/conversations/{conversationId}/tags/{tagId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tag for the provided ID.
    * @summary Gets a tag
    * @param {string} conversationId ConversationId
    * @param {string} tagId TagId
    * @throws {RequiredError}
    */
    getTag(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getTag.');
        }
        const path = `/conversations/{conversationId}/tags/{tagId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the tags for a conversation with the provided ID.
    * @summary Get tags
    * @param {string} conversationId ConversationId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Search] Odata search param
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @throws {RequiredError}
    */
    getTags(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getTags.');
        }
        const path = `/conversations/{conversationId}/tags`
            .replace(`{${'conversationId'}}`, String(params.conversationId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the tag for the provided ID.
    * @summary Update a tag
    * @param {string} conversationId ConversationId
    * @param {string} tagId TagId
    * @param {TagPutRequest} body Tag PUT request object
    * @throws {RequiredError}
    */
    updateTag(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling updateTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateTag.');
        }
        const path = `/conversations/{conversationId}/tags/{tagId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the language translation for the given message
    * @summary Get message translation
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {string} languageCode LanguageCode
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getTranslation(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getTranslation.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getTranslation.');
        }
        // verify required parameter 'languageCode' is not null or undefined
        if (params.languageCode === null || params.languageCode === undefined) {
            throw new utils_1.RequiredError('languageCode', 'Required parameter languageCode was null or undefined when calling getTranslation.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/translations/{languageCode}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId))
            .replace(`{${'languageCode'}}`, String(params.languageCode));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the translations for the given message.
    * @summary Get message translations
    * @param {string} conversationId ConversationId
    * @param {string} messageId MessageId
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Select] Specifies which object properties should be returned. If undefined, all properties are included. Properties beginning with &#39;_&#39; are always returned.  Eg: &#x60;$select&#x3D;conversationId,accountId,createdBy&#x60;
    * @throws {RequiredError}
    */
    getTranslations(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getTranslations.');
        }
        // verify required parameter 'messageId' is not null or undefined
        if (params.messageId === null || params.messageId === undefined) {
            throw new utils_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling getTranslations.');
        }
        const path = `/conversations/{conversationId}/messages/{messageId}/translations`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'messageId'}}`, String(params.messageId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Select !== undefined) {
            query['$select'] = params.$Select;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a conversation in the context of a user. This contians user specific information, such as the number of unread messages. *Expandable subresources: conversation
    * @summary Gets a single conversation for a given user
    * @param {string} conversationId ConversationId
    * @param {string} userId UserId or &#39;me&#39;
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Expand] Odata expand param. Set &#39;$expand&#x3D;conversation&#39; to receive a full conversation object in response.
    * @throws {RequiredError}
    */
    getUserConversationById(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getUserConversationById.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserConversationById.');
        }
        const path = `/users/{userId}/conversations/{conversationId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get conversations in the context of a user. This contians user specific information, such as the number of unread messages. *Expandable subresources: conversation
    * @summary Gets conversations for a given user
    * @param {string} userId UserId or &#39;me&#39;
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Expand] Odata expand param. Set &#39;$expand&#x3D;conversation&#39; to receive a full conversation object in response.
    * @param {string} [participants] Values:  - filter(*filter*): Only returns conversations where the user participant matches *filter* (written in the style of $filter parameters).
    * @throws {RequiredError}
    */
    getUserConversations(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserConversations.');
        }
        const path = `/users/{userId}/conversations`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.participants !== undefined) {
            query['participants'] = params.participants;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get messages in which the user is mentioned. *Expandable subresources: reaction, reply, status, translation.
    * @summary Gets mentioned messages for a given user
    * @param {string} userId UserId or &#39;me&#39;
    * @param {number} [$Skip] Number of items to skip. $skip + $top must be less than or equal to 10000
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include. $skip + $top must be less than or equal to 10000
    * @param {string} [$Filter] Available Operations: [eq, ne, lt, gt, le, ge, in, and, or]. To reference embbedded resources: &#x60;$filter&#x3D;resource/any(r:r/property eq &#39;value&#39;)&#x60; Syntax is based on the OData v4.0.1 Specification
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;{property} (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc&#x60; is used.
    * @param {string} [$Expand] Odata expand param. Set &#39;$expand&#x3D;conversation&#39; to receive a full conversation object in response.
    * @throws {RequiredError}
    */
    getUserMentions(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserMentions.');
        }
        const path = `/users/{userId}/mentions`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.ChatService = ChatService;
